import { useSelector } from "react-redux"
import { RootState } from "../store"
import { useState } from "react"
import { FaWhatsapp } from "react-icons/fa";

import React from 'react';
import { useTranslation } from "react-i18next";



const TrialNotice:React.FC = ()=>{

    const Organization = useSelector((state: RootState) => state.auth.org)
    const [showTrial,setShowTrial] = useState(Organization?.planName == "Free Trial")
    const plan = Organization?.planName;
    
    const expiry = Organization?.subscriptionExpiry
    const {t} = useTranslation()
    
    if(expiry == undefined || expiry ==null){
        return <></>
    } 
    // Set the expiry date (replace with your actual expiry date)
    const expiryDate: Date = new Date(expiry); // Explicitly typing expiryDate as Date

    // Get the current date
    const currentDate: Date = new Date(); // Explicitly typing currentDate as Date

    // Calculate the difference in milliseconds
    const diffInTime: number = expiryDate.getTime() - currentDate.getTime(); // Get time in milliseconds

    // Convert milliseconds to days
    const diffInDays: number = Math.ceil(diffInTime / (1000 * 3600 * 24));
    

    return ( <div id="dropdown-cta"  className={`p-3 mt-4 ${!showTrial? "hidden":""} rounded-xl bg-brand-50 border border-brand-100`} role="alert">
        <div className="flex items-center mb-2">
        {diffInDays>0?<span className="bg-orange-100 text-orange-700 text-xs font-semibold me-2 px-2 py-0.5 rounded-full">
       {t("daysLeft")} {diffInDays}
    </span>:<span className="bg-red-100 text-red-700 text-xs font-semibold me-2 px-2 py-0.5 rounded-full">
        {t("tExpired")}
      </span>}
           <button  onClick={()=>{setShowTrial(false)}} type="button" className="ms-auto inline-flex justify-center items-center w-5 h-5 text-brand-400 rounded-lg hover:bg-brand-100 hover:text-brand-700 p-0.5 transition-colors" data-dismiss-target="#dropdown-cta" aria-label="Close">
              <span  className="sr-only">Close</span>
              <svg className="w-2.5 h-2.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                 <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
              </svg>
           </button>
        </div>
        <p className="mb-2 text-xs text-brand-700">
            {diffInDays > 0
            ? t("trialNotice", { plan, expiryDate:expiry })
            : t("trialExpired", { expiryDate:expiry })}
        </p>
        <a className="text-xs text-brand-600 underline font-medium hover:text-brand-800" href="https://wa.me/966553608481">{t("Contact Us to activate the account")}</a>
        <a
      href="https://wa.me/966553608481"
      target="_blank"
      rel="noopener noreferrer"
      className="mt-2 inline-flex items-center gap-2 px-3 py-1.5 rounded-lg bg-brand-600 text-white text-xs font-semibold hover:bg-brand-700 transition"
    >
         {t("Contact Us") }
      <FaWhatsapp className="w-5 h-5" />
     
    </a>
     </div>)

}

export default TrialNotice